<button mat-raised-button type="submit" color="primary"
        cdkFocusInitial
        [disabled]="knappDeaktivert() || arbeidPaagaar()"
        [visSpinner]="arbeidPaagaar()" [spinnerTekst]="spinnerTekst()"
        data-testid="submit-knapp">
  <ng-content/>
</button>
